import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  showTotalBeforeRewards: true,
  isFeeRefundable: false,
} satisfies RecursivePartial<CheckoutConfig>
